import { ROLES } from '@/shared/constants/roles';
import { AI_PACKAGE_FEATURE_KEYS, AI_PACKAGE_FLAGS } from '@/shared/constants/packageFeatures';

export const jobsRoutes = [
  {
    path: 'jobs',
    name: 'jobs',
    component: () => import('./views/JobsView.vue'),
    meta: {
      requiredRole: ROLES.INSTITUTION_ADMIN,
      requiredFeature: AI_PACKAGE_FEATURE_KEYS.ASYNC_JOB_MONITOR,
      requiredFeatureFlag: AI_PACKAGE_FLAGS.viewProcessingStatus,
    },
  },
];
